import React, { useEffect, useState } from 'react';
import MXNavBar from '../../components/navbar/MXNavBar';
import { useTranslation } from 'react-i18next';
import { List, Tabs } from 'antd-mobile';
import './index.css'
import HotFaq from './hotFaq/HotFaq';
import CommonUtil from '../../utils/CommonUtil';
import AddConnect from './addAndConnect/AddConnect';
import ShootFaq from './shootFaq/ShootFaq';
import MonitorFaq from './monitorFaq/MonitorFaq';
import SdFaq from './sdFaq/SdFaq';
import BatteryFaq from './batteryFaq/BatteryFaq';

const HelpCenter = props => {
    const { t } = useTranslation()

    const [currentKey, setCurrentKey] = useState('1')
    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('help'))
        }
    }

    const saveCurrentKey = (key) => {
        window.sessionStorage.setItem('tabActiveKey', key)
        setCurrentKey(key)
    }

    useEffect(() => {
        postTitle()
        const savedKey = window.sessionStorage.getItem('tabActiveKey')
        console.log('savedKey: ', savedKey)
        if (savedKey != null) {
            setCurrentKey(savedKey)
        }
    }, [])

    console.log('HelpCenter currentKey: ', currentKey)
    return <div className='App'>
        <div className='tab'>
            <div style={{ height: 17 }}></div>
            <Tabs defaultActiveKey={currentKey}
                activeKey={currentKey}
                activeLineMode='fixed'
                style={{
                    '--fixed-active-line-width': '22px',
                    '--active-line-color': '#7C5AFE',
                    '--active-title-color': '#7C5AFE',
                    '--active-line-height': '3px',
                    '--prefix-padding-right': '0px',
                    '--adm-color-border': 'transparent',
                    '--adm-color-background': 'transparent'
                }}
                onChange={key => {
                    console.log('tab onchange key: ', key)
                    saveCurrentKey(key)
                }}>
                <Tabs.Tab title={t('hot_faq')} key='1'>
                    <HotFaq />
                </Tabs.Tab>
                <Tabs.Tab title={t('add_and_connect')} key='2'>
                    <AddConnect />
                </Tabs.Tab>
                <Tabs.Tab title={t('camera_shoot')} key='3'>
                    <ShootFaq />
                </Tabs.Tab>
                <Tabs.Tab title={t('camera_monitor')} key='4'>
                    <MonitorFaq />
                </Tabs.Tab>
                <Tabs.Tab title={t('camera_sdcard')} key='5'>
                    <SdFaq />
                </Tabs.Tab>
                <Tabs.Tab title={t('camera_battery')} key='6'>
                    <BatteryFaq />
                </Tabs.Tab>
            </Tabs>
        </div>
    </div>
}

export default HelpCenter